import * as logger from 'universal-logger';

export const assignIfSupported = (value, options) => {
  if (!value) {
    return null;
  }
  if (options.includes(value)) {
    return value;
  }
  logger.error(`Cancel Flow Step Modelling Error: ${value} does not match a supported option`, { options });
  return null;
};

export const ITEM_TYPE = {
  checkmark: 'checkmark',
  text: 'text', // default
};

export const TEXT_STYLE = {
  bold: 'bold',
  light: 'light',
  medium: 'medium',
  header: 'header',
  legalese: 'legalese',
};

export const CTA_TYPE = {
  button: 'button',
  link: 'link', // default
};

export const BUTTON_THEMES = {
  primary: 'primary', // client default
  tertiary: 'tertiary',
  danger: 'danger',
  'danger-outline': 'tertiary', // web doesnt support/use danger-outline so we will use tertiary (per design)
};

export const STEP_PREFIX = {
  offer: 'offer',
  confirm: 'confirm',
  exitTo: 'exit-to',
};

export const STEP_SUFFIX = {
  dynamicPlan: 'dynamic-plan',
  litePlan: 'lite-plan',
  selfCancel: 'self-cancel',
  cx: 'cx',
};

export const EXIT_TO_SELF_CANCEL = `${STEP_PREFIX.exitTo}-${STEP_SUFFIX.selfCancel}`;
export const EXIT_TO_CX = `${STEP_PREFIX.exitTo}-${STEP_SUFFIX.cx}`;

export const isDynamicStepId = stepId => stepId.includes(STEP_SUFFIX.dynamicPlan);
